import * as React from "react";

import {RequestInfo} from "@repo/shared-core";

import {withStrings} from "./locales/privacy-policy/load-strings.tsx";
import SpanishPrivacyPolicyPage from "./privacy-policy-page-es.tsx";
import PortuguesePrivacyPolicyPage from "./privacy-policy-page-pt.tsx";
import PrivacyPolicyPage from "./privacy-policy-page.tsx";

type Props = Record<any, any>;

class PrivacyPolicy extends React.Component<Props> {
    render(): React.ReactNode {
        if (RequestInfo.kaLocale === "pt") {
            return <PortuguesePrivacyPolicyPage />;
        }
        if (RequestInfo.kaLocale === "es") {
            return <SpanishPrivacyPolicyPage />;
        }
        return <PrivacyPolicyPage />;
    }
}

export default withStrings(PrivacyPolicy);
